import { createContext, useEffect, useState } from 'react';
import './App.css';
import Homepage from './pages/Homepage';
import Navbar from './components/Navbar';
import { createBrowserRouter, Outlet, useLocation, useNavigate } from 'react-router-dom';
import Favorites from './pages/Favorites';
import Footer from './components/Footer';
import Categories from './pages/Categories';
import Planner from './pages/Planner';
import ShoppingList from './pages/ShoppingList';
import { BackToTop, OfflineBanner } from './components/common/Common';
import DevToolsShield from './components/DevToolsShield';
import { readJSON, writeJSON } from './utils/storage';

// create a context for theme flexibility
export const ThemeContext = createContext(null)

export const appRouter = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            {
                path: "/",
                element: <Homepage />,
            },
            {
                path: "favorites",
                element: <Favorites />,
            },
            {
                path: "categories",
                element: <Categories />,
            },
            {
                path: "planner",
                element: <Planner />,
            },
            {
                path: "shopping",
                element: <ShoppingList />,
            },
        ],
    },
    {
        future: {
            v7_partialHydration: true,
            v7_skipActionErrorRevalidation: true,
        },
    },
]);

const THEME_KEY = "recify_theme";

// Saved choice first, otherwise follow the operating system
const initialTheme = () => {
    const saved = readJSON(THEME_KEY, null);
    if (saved === "dark" || saved === "light") return saved === "dark";
    return typeof window.matchMedia === "function" && window.matchMedia("(prefers-color-scheme: dark)").matches;
};

function App() {

    const [theme, setTheme] = useState(initialTheme)
    const [search, setSearch] = useState({ query: "", nonce: 0 })
    const navigate = useNavigate()
    const location = useLocation()
    const toggleTheme = () => {
        setTheme((t) => {
            writeJSON(THEME_KEY, t ? "light" : "dark")
            return !t
        })
    }

    useEffect(() => {
        document.documentElement.dataset.theme = theme ? "dark" : "light"
        document.querySelector('meta[name="theme-color"]')?.setAttribute("content", theme ? "#15110e" : "#faf5ea")
    }, [theme])

    // Start each page at the top
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [location.pathname])

    const handleSearch = (query) => {
        setSearch((prev) => ({ query, nonce: prev.nonce + 1 }))
        navigate("/")
    }

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            <div className="App">
                <DevToolsShield />
                <OfflineBanner />
                <Navbar onSearch={handleSearch} />
                <div className="page" key={location.pathname}>
                    <Outlet context={{ search }} />
                </div>
                <Footer />
                <BackToTop />
            </div>
        </ThemeContext.Provider>
    );
}

export default App;
